import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Sensible defaults that mirror /api/content/contact_info so pages render
// correctly on first paint before the network request resolves.
const DEFAULT_CONTACT = {
  business_name: "Auvergne Tech Racing",
  phone: "+33649070820",
  phone_display: "06 49 07 08 20",
  email: "auvergne.tech.racing@gmail.com",
  email_sender: "contact@auvergnetechracing.com",
  street: "47 rue Jules Verne",
  postal_code: "63100",
  city: "Clermont-Ferrand",
  country: "FR",
  maps_url: "https://www.google.com/maps/search/Auvergne+Tech+Racing+Clermont-Ferrand",
  opening_hours_display: "Lundi - Vendredi : 8h - 12h30 / 13h30 - 18h",
};

/**
 * Fetches ATR's business coordinates from the CMS.
 * All public pages should use this hook so a single admin edit propagates everywhere.
 */
export function useContactInfo() {
  const [info, setInfo] = useState(DEFAULT_CONTACT);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/content/contact_info`)
      .then((r) => {
        if (cancelled) return;
        // Merge over defaults so any missing field falls back gracefully.
        setInfo((prev) => ({ ...prev, ...(r.data || {}) }));
      })
      .catch(() => {
        // Silent fallback — defaults are fine.
      });
    return () => { cancelled = true; };
  }, []);

  const fullAddress = [
    info.street,
    [info.postal_code, info.city].filter(Boolean).join(" "),
  ].filter(Boolean).join(", ");

  return { ...info, fullAddress };
}
